function SectionTitle({ title }: { title: string }) {
  return (
    <h1 className="text-primary-3 my-4 text-center text-2xl md:text-3xl font-bold underline underline-offset-6 decoration-secondary-2 decoration-3">
      {title}
    </h1>
  );
}

export default SectionTitle;
